import Status from "./Status";

export { Page }

function Page() {
  return <Status />;
}